import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  stepIndex: number;
  className?: string;
  /** Smaller number circle for compact list rows. */
  size?: 'default' | 'small';
};

const CIRCLE_CLASSNAMES: Record<NonNullable<Props['size']>, string> = {
  default: 'h-4 w-4 text-[10px]',
  small: 'h-3 w-3 text-[8px]',
};

/** Inline "Mail" label with a small numbered circle (stepIndex is 0-based). */
const MailStepBadge: FC<Props> = ({
  stepIndex,
  className,
  size = 'default',
}) => (
  <span
    className={classNames(
      'inline-flex items-center gap-1 font-medium',
      className,
    )}
  >
    <span>Mail</span>
    <span
      className={classNames(
        'inline-flex shrink-0 items-center justify-center rounded-full bg-secondary-100 font-bold leading-none text-white',
        CIRCLE_CLASSNAMES[size],
      )}
      aria-label={`Mail ${stepIndex + 1}`}
    >
      {stepIndex + 1}
    </span>
  </span>
);

export default MailStepBadge;
